import React, { useEffect, useState, useRef } from 'react';
import { Text, View, Image, StyleSheet, Linking, ActivityIndicator, Platform, TextInput, TouchableOpacity} from 'react-native';
import Modal from '../components/PlatformModal';
import { MaterialCommunityIcons, MaterialIcons } from '../components/PlatformSpecificIcons';
import { useMQTT } from '../components/MQTTContext';
import moment from 'moment-timezone';
import Dropdown from '../components/Dropdown';
import Switch from '../components/forms/Switch';
import PowerSwitch from '../components/forms/PowerSwitch';
import AppTextInput from '../components/TextInputRef';
let NativeModules;
let NativeEventEmitter;

if (!(Platform.OS === 'web' || Platform.OS === 'macos')) {
  NativeModules = require('react-native').NativeModules;
  NativeEventEmitter = require('react-native').NativeEventEmitter;
}

import Screen from '../components/Screen';
import alert from '../components/alert';
import Button from '../components/Button';
import { SquareButton, ButtonRow, ActionButton, DeleteButton } from '../components/JCButtons';
import routes from "../navigation/routes";
import useAuth from "../auth/useAuth";
import useApi from "../hooks/useApi";
import keepConnectApi from "../api/keepConnectsApi";
import keepConnectStore from '../auth/keepConnectStorage';
import secureStorage from "../auth/vpnSecureStorage";
import { ErrorMessage, ErrorMessage2 } from "../components/forms";
import colors from '../config/colors';

// New imports for device views architecture
import { StatusCard, DeviceInfoCard } from '../components/cards';
import {
    deviceViewMap,
    deviceScreenMap,
    deviceIconMap,
    DeviceModals,
    hasScreenOverride,
} from '../components/deviceViews';


function DeviceScreen2({ route, navigation }){
    // ═══════════════════════════════════════════════════════════════════
    // ALL STATE DECLARATIONS - UNCHANGED FROM ORIGINAL
    // ═══════════════════════════════════════════════════════════════════
    const auth = useAuth();
    const { client, messages, triggerHeartbeat } = useMQTT();
    const [keepConnectsArray, setKeepConnectsArray] = useState([{label: "No Keep Connects Registered", value: "null"}]);
    const [incompatibleKeepConnects, setIncompatibleKeepConnects] = useState([]);
    const [boolIncompatibleKeepConnects, setBoolIncompatibleKeepConnects] = useState(false);
    const [isSubscribed, setSubscription] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [selectedValue, setSelectedValue]= useState("");
    const [selectedName, setSelectedName]= useState();
    const getKeepConnectSettingsApi = useApi(keepConnectApi.getKeepConnectSettings);
    const triggerKeepConnectApi = useApi(keepConnectApi.triggersKeepConnectApi);
    const removeKeepConnectApi = useApi(keepConnectApi.removeKeepConnect);
    const renameKeepConnectApi = useApi(keepConnectApi.renameKeepConnect);
    const [defaultKeepConnect, setDefaultKeepConnect] = useState("");
    const [visibleVPN, setVisibleVPN] = useState(false);
    const [selectedTunnelType, setSelectedTunnelType] = useState(0);
    const [selectedConnType, setSelectedConnType] = useState(0);
    const [storeVPN, setStoreVPN] = useState(true);
    const [vpnPassword, setVPNpassword] = useState("");
    const [vpnPort, setVPNport] = useState("4550");
    const [visibleTrigger, setVisibleTrigger] = useState(false);
    const [visibleTriggerF, setVisibleTriggerF] = useState(false);
    const renameModalRef = useRef();
    const newDeviceNameRef = useRef();
    const [visibleTrigger2, setVisibleTrigger2] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);
    const [requestMessage, setRequestMessage] = useState("Error Communicating with Server");
    const [errorFromServer, setErrorFromServer] = useState(false);
    const [serverMessage, setServerMessage] = useState("");
    const [emptyKeepConnects, setEmptyKeepConnects] = useState(true);
    const [updateNeeded, setUpdateNeeded] = useState(false);
    const [updateNeededHigherLevel, setUpdateNeededHigherLevel] = useState(false);
    const [data, setSettings] = useState();
    const [newSettings1, setNewSettings1] = useState(false);
    const [newSettings5, setNewSettings5] = useState(false);
    const [enablePowerPal, setPowerPal] = useState(false);
    const [deviceType, setDeviceType] = useState(0);
    const [isConnected, setIsConnected] = useState(false);
    const [appTimezone, setAppTimeZone] = useState("America/New_York");
    const [moreAppSettings, setMoreAppSettings] = useState();
    const [enterpriseOrPro, setEnterpriseOrPro] = useState(false);
    const [vpnEnabled, setVPNenabled] = useState(false);
    const [vpnConnectionType, setVpnConnectionType] = useState("");
    const [thisIsVPN, setThisIsVPN] = useState(false);
    const isDesktop = Platform.OS === 'windows' || Platform.OS === 'macos';
    const [isPowerOn, setIsPowerOn] = useState(false);
    const [awaitingStateChange, setAwaitingStateChange] = useState(false);
    const [intendedPowerState, setIntendedPowerState] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [deviceData, setDeviceData] = useState({});
    const [battEnable, setBattEnable] = useState(false);

    const TIMEOUT_DURATION = 30000;

    // ═══════════════════════════════════════════════════════════════════
    // ALL HELPER FUNCTIONS - UNCHANGED FROM ORIGINAL
    // ═══════════════════════════════════════════════════════════════════
    const getMacWithoutColons = (mac) => {
        return mac.replace(/:/g, '');
    };

    const initiatePowerToggle = (state) => {
        alert(
            "Set On/Off",
            "This is NOT a Power Cycle Event. This will turn the socket off or on and it will remain that way until you change it again. This could result in loss of communication if a router/modem is connected. To cycle power off/on, please use the Power Cycle button instead.",
            [
                {
                  text: "Cancel",
                  onPress: () => console.log("Cancel Pressed"),
                  style: "cancel"
                },
                { text: "Proceed", onPress: () => {
                    handlePowerToggle(state);
                } }
              ]
          );
    }

    const handlePowerToggle = (state) => {
        const message = state ? 'on' : 'off';
        setIntendedPowerState(state);
        setAwaitingStateChange(true);
        setIsPowerOn(state);
        setButtonDisabled(true);
        if (client && client.isConnected()) {
            const mqttMessage = new Paho.MQTT.Message(message);
            mqttMessage.destinationName = `${getMacWithoutColons(route.params.item.MAC)}/in`;
            client.send(mqttMessage);
            console.log('Sent MQTT message:', message);
            setTimeout(() => {
                setAwaitingStateChange(false);
                setButtonDisabled(false);
                if(awaitingStateChange && isPowerOn != intendedPowerState){
                    alert(
                        "Error",
                        "Device did not respond to power toggle request.",
                        [
                            { text: "OK", onPress: () => {} }
                        ]
                        );
                }
            }, TIMEOUT_DURATION);
        } else {
          console.log('MQTT client is not connected');
        }
      };

    const handleRequestStatus = () => {
        const message = "status";
        if (client && client.isConnected()) {
            const mqttMessage = new Paho.MQTT.Message(message);
            mqttMessage.destinationName = `${getMacWithoutColons(route.params.item.MAC)}/in`;
            client.send(mqttMessage);
            console.log('Sent MQTT message:', message);
        } else {
          console.log('MQTT client is not connected');
        }
      };

    // ═══════════════════════════════════════════════════════════════════
    // ALL USE EFFECTS - UNCHANGED FROM ORIGINAL
    // ═══════════════════════════════════════════════════════════════════
    useEffect(() => {
        if (client && client.isConnected()) {
          const topic = `${getMacWithoutColons(route.params.item.MAC)}/out`;
          client.subscribe(topic, { qos: 0 });
        }
        const intervalId = setInterval(() => {
          handleRequestStatus();
        }, 40000);
        return () => clearInterval(intervalId);
      }, [client]);

      useEffect(() => {
        if (messages.length > 0) {
          const latestMessage = messages[messages.length - 1];
          console.log('Received MQTT message:', latestMessage);
          if (latestMessage.mac === route.params.item.MAC) {
            setDeviceData(latestMessage);

            if (latestMessage.state) {
                setIsPowerOn(latestMessage.state);
                if(awaitingStateChange && latestMessage.state == intendedPowerState){
                    setAwaitingStateChange(false);
                    setButtonDisabled(false);
                }
            }
            setTimeout(() => {
                if (client && client.isConnected()) {
                    const mqttMessage = new Paho.MQTT.Message("status");
                    mqttMessage.destinationName = `${getMacWithoutColons(route.params.item.MAC)}/in`;
                    client.send(mqttMessage);
                    console.log('Sent Status Keep Alive:', "status");
                } else {
                  console.log('MQTT client is not connected');
                }
            }, 40000);
          }
        }
      }, [messages]);

    const VPN_STATES = {
        Disconnected: 0,
        Connecting: 1,
        Connected: 2,
        Disconnecting: 3,
        Reconnecting: 4,
      };
    const [vpnState, setVPNState] = useState(VPN_STATES.disconnected);

    const [vpnSettings, setVpnSettings] = useState({
        vpnPassword: '',
        selectedTunnelType: 0,
        selectedConnType: 0,
        vpnPort: '4550',
        vpnRoute: '',
        vpnRouteSubnet: '',
        storeVPN: true,
        init: false,
      });


      useEffect(() => {
        loadKeepConnects();
        handleRequestStatus();
        if(!(Platform.OS === 'web' || isDesktop)){
                console.log("VPN Interface: ", NativeModules.KCVPNInterface);
                const { KCVPNInterface } = NativeModules;
                const handleStatusChange = (response) => {
                    if(response.mac == route.params.item.MAC) {
                        setThisIsVPN(true);
                    } else{
                        setThisIsVPN(false);
                    }
                    const state = VPN_STATES[response.status];
                    if (state !== undefined) {
                    setVPNState(state);
                    }
                };

                KCVPNInterface.getVPNStatus((response) => {
                    if(response.mac == route.params.item.MAC) {
                        setThisIsVPN(true);
                    } else{
                        setThisIsVPN(false);
                    }
                    const state = VPN_STATES[response.status];
                    if (state !== undefined) {
                    setVPNState(state);
                    }
                });

                const eventEmitter = new NativeEventEmitter(KCVPNInterface);

                const subscription = eventEmitter.addListener('vpnStatusDidChange', handleStatusChange);

                return () => {
                    subscription.remove();
                    const topic = `${getMacWithoutColons(route.params.item.MAC)}/out`;
                    client?.unsubscribe(topic);
                };
        }

    }, []);


    useEffect(() => {
        if(!(Platform.OS === 'web' || isDesktop)){
                const { KCVPNInterface } = NativeModules;
                if (thisIsVPN && vpnState === VPN_STATES.Connected) {
                    if (typeof KCVPNInterface.getVPNConnectionType === 'function') {
                        KCVPNInterface.getVPNConnectionType((connectionType) => {
                            setVpnConnectionType(connectionType);
                        });
                    } else{
                        setVpnConnectionType("Relay");
                    }
                } else {
                setVpnConnectionType("");
                }
        }
      }, [thisIsVPN, vpnState]);


    // ═══════════════════════════════════════════════════════════════════
    // DATA LOADING - UNCHANGED FROM ORIGINAL
    // ═══════════════════════════════════════════════════════════════════
    const loadKeepConnects = async () => {
        keepConnectStore.store("keepConnect", (route.params.item.MAC));
        const response = await getKeepConnectSettingsApi.request("\"" + route.params.item.MAC +"\"");
        const settings = await secureStorage.getSettings(route.params.item.MAC);
        if(settings){
            setVpnSettings(settings);
        }
        setSettings(response.data);
        setVPNenabled(response.data[0].firmware.includes("VPN"));
        setBattEnable(response.data[0].firmware.includes("BATT"));

        const firmwareString = response.data[0].firmware;
        const majorVersionStart = firmwareString.indexOf("_V") + 2;
        const majorVersionEnd = firmwareString.indexOf("_", majorVersionStart);
        const majorVersion = parseInt(firmwareString.substring(majorVersionStart, majorVersionEnd), 10);
        setNewSettings1(majorVersion >= 3);
        setNewSettings5(majorVersion >= 5);

        setDeviceType(response.data[0].powerPal ? response.data[0].powerPal : "0");
        setIsPowerOn(JSON.parse(response.data[0].realtimeData)?.state);
        setDeviceData(JSON.parse(response.data[0].realtimeData));
        var then = moment(response.data[0].lastConnectTime, "YYYY-DD-MM HH:mm:ss");
        var now = moment().tz("America/New_York");
        setIsConnected(now.diff(then, 'minutes') <= (response.data[0].powerPal && parseInt(response.data[0].powerPal) > 0 ? (response.data[0].pollTime / 60000 + 2) : 7));

        const storedTimezone = await keepConnectStore.get("kc_appTimezone");
        const correctedStoredTimezone = (storedTimezone !== null ? storedTimezone.replace(/\"/g, "") : "America/New_York");
        setAppTimeZone(correctedStoredTimezone);
        const storedMoreAppSettings = await keepConnectStore.get("kc_appsettings");
        setMoreAppSettings(JSON.parse(storedMoreAppSettings));
        setEnterpriseOrPro(auth?.userPermissions?.license == "enterprise" || auth?.userPermissions?.license == "pro");
        checkAndSetFirmwareCompatibility();
        setIsLoading(false);
        setRefreshing(false);
        }

    if (updateNeeded || updateNeededHigherLevel){
        if(Platform.OS === 'web' || isDesktop) setIsLoading(true);
        setRefreshing(true);
        setUpdateNeeded(false);
        if(updateNeededHigherLevel) route.params.changedDevices(true);
        setUpdateNeededHigherLevel(false);
        loadKeepConnects();
    }

    const convertTimezone = (item) =>{
        moment.tz.setDefault("America/New_York");
        var timestamp = moment(item, "YYYY-DD-MM HH:mm:ss");
        return timestamp.tz(appTimezone).format('YYYY-MM-DD HH:mm:ss');
    }

    const checkAndSetFirmwareCompatibility = () => {
        if (route.params.item.firmware.includes("KeepConnect") || route.params.item.firmware.includes("Pal")) setBoolIncompatibleKeepConnects(false);
        else setBoolIncompatibleKeepConnects(true);
    }

    // ═══════════════════════════════════════════════════════════════════
    // ALL HANDLERS - UNCHANGED FROM ORIGINAL
    // ═══════════════════════════════════════════════════════════════════
    const handleRequestFirmwareUpdate = async () => {
        const keepConnectCodeForEmail = route.params.item.WebID;

        alert(
            "Firmware Update",
            "Our Support Staff will stage your device to receive the update. This will cause your device to reboot and will power cycle your router/modem as well. The update will happen within appx 1hr once our staff has staged your device for upgrade. If you require a specific time for your device to be updated, please note this in the email generated by clicking the \"Proceed\" Button.",
            [
                {
                  text: "Cancel",
                  onPress: () => console.log("Cancel Pressed"),
                  style: "cancel"
                },
                { text: "Proceed", onPress: () => {
                    Linking.openURL('mailto: support@johnson-creative.com?subject=Firmware Update Request&body=Please Update Keep Connect Device with WebID ' + keepConnectCodeForEmail);
                } }
              ]
          );
    }

    const handleLearnMoreFirmwareUpdate = ()=>{
        alert(
            "Firmware Update Needed",
            "The selected device requires newer firmware for full compatibility with Keep Connect Cloud Services. The \"Trigger Reset\" and \"Change Settings\" features will not work until the firmware is updated. All other features will work as expected without updating the firmware. Click the \"Request Firmware Update\" option to generate firmware update request email.",
            [
              { text: "OK", onPress: () => {} }
            ]
          );
    }

    const toggleModal = () => {
        setVisibleTrigger(!visibleTrigger);
        };

    const handleTrigger = async (sendIt) => {
        setVisibleTrigger(false);
        if(sendIt){
        const keepConnectCode = route.params.item.MAC;
        const response = await triggerKeepConnectApi.request({keepConnects: keepConnectCode.replace(/\"/g, ""), triggerType: "remoteReboot"});
        if (!response.ok){
            setIsLoading(false);
            return setRequestFailed(true);
        }
        setServerMessage("Unknown Server Error");
        if( !response.data || !response.data.MSG ){
          setIsLoading(false);
          return setErrorFromServer(true);
        }
        if (response.data.MSG != "Success!"){
          setErrorFromServer(true);
          setServerMessage(response.data.MSG);
          setIsLoading(false);
          return;
        }
        alert(
            "Success!",
            "Power Cycle was staged successfully. Your device will read and apply this trigger in appx 5min.",
            [
              { text: "OK", onPress: () => {} }
            ]
          );
        triggerHeartbeat(keepConnectCode);
        setRequestFailed(false);
        setErrorFromServer(false);
        setServerMessage("");
        }
        }

    const renameKeepConnect = async () => {
        renameModalRef.current?.closeModal();
        console.log("New Device Name: ", newDeviceNameRef.current);
        route.params.item.Name = newDeviceNameRef.current;
        const response = await renameKeepConnectApi.request(route.params.item.MAC, newDeviceNameRef.current);
        setUpdateNeededHigherLevel(true);
        loadKeepConnects();
    }

    const handleTriggerFirmwareUpdate = async (sendIt) => {
        setVisibleTriggerF(false);
        if(sendIt){
        const keepConnectCode = route.params.item.MAC;
        const response = await triggerKeepConnectApi.request({keepConnects: keepConnectCode.replace(/\"/g, ""), triggerType: "firmware"});
        if (!response.ok){
            setIsLoading(false);
            return setRequestFailed(true);
        }
        setServerMessage("Unknown Server Error");
        if( !response.data || !response.data.MSG ){
          setIsLoading(false);
          return setErrorFromServer(true);
        }
        if (response.data.MSG != "Success!"){
          setErrorFromServer(true);
          setServerMessage(response.data.MSG);
          setIsLoading(false);
          return;
        }
        alert(
            "Success!",
            "The unit will check for latest firmware and update if needed (it may take a few minutes). If an update is available, the device will blink blue led and reboot WITHOUT cycling the output power, and reconnect to internet immediately.",
            [
              { text: "OK", onPress: () => {} }
            ]
          );
        triggerHeartbeat(keepConnectCode);
        setRequestFailed(false);
        setErrorFromServer(false);
        setServerMessage("");
        }
        }

    function getNetworkAddress(ip, subnet) {
        let ipArray = ip.split(".");
        let subnetArray = subnet.split(".");
        let networkAddressArray = [];

        for(let i = 0; i < 4; i++) {
            networkAddressArray[i] = Number(ipArray[i]) & Number(subnetArray[i]);
        }

        return networkAddressArray.join(".");
    }


    const handleVPNsave = async (proceed) => {
        setVisibleVPN(false);
        if(!proceed) return;
        vpnSettings.init = true;
        if(vpnSettings.storeVPN){
            await secureStorage.storeSettings(route.params.item.MAC, vpnSettings);
        } else{
            await secureStorage.removeSettings(route.params.item.MAC);
        }
    }

    const handleDeregister = async (sendIt) => {
        setVisibleTrigger2(false);
        if(sendIt){
        setIsLoading(true);
        const keepConnectCode = route.params.item.MAC;
        const response = await removeKeepConnectApi.request(keepConnectCode.replace(/\"/g, ""));
        if (!response.ok){
            setIsLoading(false);
            return setRequestFailed(true);
        }
        setServerMessage("Unknown Server Error");
        if( !response.data || !response.data.MSG ){
          setIsLoading(false);
          return setErrorFromServer(true);
        }
        if (response.data.MSG != "Success!"){
          setErrorFromServer(true);
          setServerMessage(response.data.MSG);
          setIsLoading(false);
          return;
        }
        alert(
          "Success!",
          "Your Keep Connect was successfully removed!",
          [
            { text: "OK", onPress: () => {} }
          ]
        );
        setRequestFailed(false);
        setErrorFromServer(false);
        setServerMessage("");
        route.params.changedDevices(true);
        navigation.goBack();
        }
        }

    const displayVPNNotice = () => {
        var msg = "";
        if (auth.userPermissions.role !== 'admin'){
            msg = "Not Allowed for Read Only Access.";
        } else if(!enterpriseOrPro){
            msg = "Pro Or Enterprise License Is Required.";
        } else if(!vpnEnabled){
            msg = "Device requires firmware update.";
        } else if(data[0].vpnMode == "0"){
            msg = "Device VPN setting is set to off. Send new settings to the device and refresh this page to clear this error.";
        }
        alert(
            "Error",
            msg,
            [
                { text: "OK", onPress: () => {} }
            ]
            );
    }

    // ═══════════════════════════════════════════════════════════════════
    // DEVICE CONTEXT - Props bundle for device views/screens
    // ═══════════════════════════════════════════════════════════════════
    const deviceContext = {
        // Data
        data,
        deviceData,
        deviceType,
        isConnected,
        isLoading,
        refreshing,

        // Power state
        isPowerOn,
        buttonDisabled,
        awaitingStateChange,

        // VPN
        vpnState,
        vpnEnabled,
        thisIsVPN,
        vpnSettings,
        vpnConnectionType,
        VPN_STATES,

        // Settings/permissions
        auth,
        enterpriseOrPro,
        newSettings1,
        newSettings5,
        battEnable,
        moreAppSettings,

        // Handlers
        handleTrigger,
        handleDeregister,
        handlePowerToggle,
        initiatePowerToggle,
        handleVPNsave,
        handleTriggerFirmwareUpdate,
        handleRequestStatus,
        renameKeepConnect,
        displayVPNNotice,
        toggleModal,

        // Modal visibility
        visibleTrigger,
        visibleTrigger2,
        visibleTriggerF,
        visibleVPN,

        // Modal setters
        setVisibleTrigger,
        setVisibleTrigger2,
        setVisibleTriggerF,
        setVisibleVPN,
        setVpnSettings,

        // Refresh
        setUpdateNeeded,
        setUpdateNeededHigherLevel,

        // Navigation
        navigation,
        route,

        // Refs
        renameModalRef,
        newDeviceNameRef,

        // Utilities
        convertTimezone,
        appTimezone,
    };

    // ═══════════════════════════════════════════════════════════════════
    // RENDER - New architecture with device-specific views/screens
    // ═══════════════════════════════════════════════════════════════════

    // Check for full screen override (e.g., PumpPal)
    const FullScreenComponent = deviceScreenMap[deviceType];
    if (FullScreenComponent && !isLoading) {
        return <FullScreenComponent {...deviceContext} />;
    }

    // Get device-specific view component
    const DeviceView = deviceViewMap[deviceType];

    return(
        <Screen isLoading={refreshing} setUpdateNeeded={setUpdateNeeded}>
        {isLoading ? <View style={{paddingTop: 120}}><ActivityIndicator size="large" color={colors.primary}/></View> :
        <React.Fragment>
        <View style={{padding: 20}}>
        {/* Error Messages */}
        <ErrorMessage
        error={requestMessage}
        visible={requestFailed}
        />
        <ErrorMessage
        error={serverMessage}
        visible={errorFromServer}
        />
        <ErrorMessage2
          error={"Firmware Update Required\nFor Selected Keep Connect"}
          visible={boolIncompatibleKeepConnects}
        />
        {boolIncompatibleKeepConnects ? <Text style={styles.TextStyle} onPress={ ()=> handleLearnMoreFirmwareUpdate() } >Learn More</Text> : null}
        {boolIncompatibleKeepConnects ? <><Text style={styles.TextStyle} onPress={ ()=> handleRequestFirmwareUpdate() } >Request Firmware Update</Text><Text></Text></> : null}

        {/* Status Card */}
        <StatusCard
            isConnected={isConnected}
            deviceName={route.params.item.Name}
            onRenamePress={() => renameModalRef.current.openModal()}
        />

        {/* Device Info Card */}
        <DeviceInfoCard
            webId={data[0].id}
            ipAddress={data[0].IPaddress}
            macAddress={data[0].macAddress}
            lastConnected={`${convertTimezone(data[0].lastConnectTime)} (${moment().tz(appTimezone).format('z')})`}
        />

        {/* Device-specific View */}
        {DeviceView ? (
            <DeviceView {...deviceContext} />
        ) : (
            // Fallback for unknown device types
            <View style={styles.fallbackContainer}>
                <Text>Unknown device type: {deviceType}</Text>
            </View>
        )}

        {/* VPN Control Section - only for non-battery devices on mobile */}
        {Platform.OS !== 'web' && !battEnable && (
            <View style={styles.vpnBox}>
                <Text style={{fontWeight: "bold", alignSelf: "center"}}>VPN Control</Text>
                {thisIsVPN && vpnState === VPN_STATES.Connecting ? <Text style={{alignSelf: "center"}}>Initiating Connection...</Text> : <></>}
                {thisIsVPN && vpnState === VPN_STATES.Disconnecting ? <Text style={{alignSelf: "center"}}>Disconnecting...</Text> : <></>}
                <View style={{paddingTop: 2, flexDirection: "row"}}>
                <View style={{flex: 1, marginRight: 5}}>
                <Button
                    title="Start"
                    onPress={() => {
                        if(!vpnEnabled || !enterpriseOrPro || data[0].vpnMode == "0" || auth.userPermissions.role !== 'admin') {displayVPNNotice(); return;}
                        if(vpnSettings.init){
                            NativeModules.KCVPNInterface.stopVPN((success) =>{
                            NativeModules.KCVPNInterface.setVPNParams(
                                vpnSettings.selectedConnType == 0 ? "vpnserver.johnson-creative.com" : data[0].IPaddress,
                                vpnSettings.selectedConnType == 0 ? "4550" : vpnSettings.vpnPort,
                                data[0].macAddress,
                                vpnSettings.vpnPassword,
                                vpnSettings.selectedTunnelType == 1 ? "0.0.0.0" : getNetworkAddress(data[0].localIP, data[0].localSubnet),
                                vpnSettings.selectedTunnelType == 1 ? "0.0.0.0" : data[0].localSubnet,
                                vpnSettings.selectedConnType == 1
                              );
                              setThisIsVPN(true);
                              NativeModules.KCVPNInterface.startVPN((success) => {
                                  if(!success){
                                    alert(
                                        "VPN Config Failed",
                                        "The selected device failed to install the VPN profile.",
                                        [
                                          { text: "OK", onPress: () => {} }
                                        ]
                                      );
                                  }
                                });
                            })
                            } else{
                                setVisibleVPN(true);
                            }
                    }}
                />
                </View>
                <View style={{flex: 1, marginRight: 5}}>
                <Button
                    title="Stop"
                    onPress={() => {
                        if(!vpnEnabled || !enterpriseOrPro) {displayVPNNotice(); return;}
                        NativeModules.KCVPNInterface.stopVPN(()=>{});
                    }
                    }
                />
                </View>
                </View>
                <View style={{paddingTop: 2, flexDirection: "row", alignItems: 'center'}}>
                <View style={{flex: 1, marginRight: 5}}>
                <Button
                    title="Set"
                    onPress={() => {
                        if(!vpnEnabled || !enterpriseOrPro || auth.userPermissions.role !== 'admin') {displayVPNNotice(); return;}
                        setVisibleVPN(true);
                    }}
                />
                </View>
                <View style={{flex: 1, marginRight: 5, marginLeft: 25}}>
                    {thisIsVPN && vpnState === VPN_STATES.Connected ? <View style={{width:100, backgroundColor: '#33cc33', borderRadius: 30, justifyContent: 'center'}}>
                    <Text style={{marginTop: 5, marginBottom: 0, marginLeft: 10, marginRight: 10, color: "white", alignSelf: "center", fontWeight: "bold"}}>Connected</Text>
                    <Text style={{marginTop: 0, marginBottom: 5, marginLeft: 10, marginRight: 10, color: "white", alignSelf: "center"}}>({vpnConnectionType})</Text>
                    </View> :
                    <View style={{width:100, backgroundColor: 'gray', borderRadius: 30, alignContent: 'center'}}>
                    <Text style={{margin: 10, color: "white", alignSelf: "center", fontWeight: "bold"}}> Off </Text>
                    </View>}
                </View>
                </View>
            </View>
        )}

        {/* Refresh link for non-iOS */}
        {Platform.OS !== 'ios' && <Text style={styles.TextStyle} onPress={ ()=> setUpdateNeeded(true) } >Refresh</Text>}

        {/* Shared Modals */}
        <DeviceModals
            deviceName={route.params.item.Name}
            visibleTrigger={visibleTrigger}
            handleTrigger={handleTrigger}
            visibleTriggerF={visibleTriggerF}
            handleTriggerFirmwareUpdate={handleTriggerFirmwareUpdate}
            visibleTrigger2={visibleTrigger2}
            handleDeregister={handleDeregister}
            renameModalRef={renameModalRef}
            newDeviceNameRef={newDeviceNameRef}
            renameKeepConnect={renameKeepConnect}
            showVPN={!battEnable}
            visibleVPN={visibleVPN}
            handleVPNsave={handleVPNsave}
            vpnSettings={vpnSettings}
            setVpnSettings={setVpnSettings}
        />
        </View>
        </React.Fragment>}
    </Screen>
);
    }

const styles = StyleSheet.create({
    background: {
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
    },
    buttonsContainer: {
        width: "100%",
    },
    logo: {
        width: 200,
        height: 200,
        resizeMode: 'contain',
    },
    logoContainer: {
        position: "absolute",
        top: -20,
        alignItems: "center",
        width: "100%",
    },
    tagline: {
        fontSize: 25,
        fontWeight: "600",
        paddingVertical: 20,
    },
    TextStyle: {
         color: colors.primary,
         alignSelf: "center",
      },
    deviceBox: {
        borderWidth: 1,
        borderRadius: 10,
        borderColor: '#4eb9d6',
        padding: 5,
    },
    vpnBox: {
        borderWidth: 1,
        borderRadius: 10,
        borderColor: '#4eb9d6',
        padding: 10,
        marginTop: 16,
    },
    imageStyle: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 80,
        height: 25,
    },
    modalContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContent: {
        backgroundColor: 'white',
        padding: 22,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 20,
        borderColor: 'rgba(0, 0, 0, 0.1)',
        maxHeight: '80%',
    },
    modalInput: {
        borderWidth: 1,
        borderColor: colors.light,
        borderRadius: 4,
        padding: 10,
        marginBottom: 10,
        width: '100%',
    },
    fallbackContainer: {
        padding: 20,
        alignItems: 'center',
    },
    });

export default DeviceScreen2;
